import $ from "jquery"
import './../scss/style.scss';

//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common'
// import { initCookies } from './shared/cookies'
import { loadingSequence } from "./loading";
import { initEventForm } from "./shared/event-form";
import { initFormValidation } from "./shared/form-validator";
import { initScrollTo } from "./shared/scroll-to";
import { initSearchFocus } from "./shared/search-focus";
import { initContactLoader } from "./shared/contact-loader";
import { initBoocarousel } from "./shared/boocarousel";


$(() => {
  // # on ready
  initCommon()
  // initCookies()
  initEventForm()
  initFormValidation()
  initScrollTo()
  WCAG.init()
  initSearchFocus()
  initContactLoader()
  initBoocarousel()
  // loading sequence
  loadingSequence()
});

$(window).on( "load", ()=> {
  // # on load
});